<template>
  <div v-if="courses.length > 0">
    <div v-for="(area, index) in getAreas" :key="index">
      <div class="absolute">
        <div :ref="area" class="relative target-top"></div>
      </div>
      <h2 class="section-title m-4 text-center text-lg">{{ area }}</h2>
      <div id="courseList">
        <ul class="courselist pl-4">
          <li v-for="course in getCourses(area)" :key="course.course_id">
            <div class="course">
              <div class="course-info">
                <h3 class="course-title font-semibold">
                  {{ course.title }}
                </h3>
                <img v-lazy="course.images !==undefined ? course.images[0] : ''" class="course-image" />
                <p class="course-detail" v-html="course.detail"></p>
              </div>
              <div v-if="createPlan" class="course-button m-4">
                <a class="button-primary block" v-on:click="showModal(course)">
                  {{ $t('tour_display_detail_label') }}
                </a>
              </div>
              <div v-else class="course-button m-4">
                <a class="button-primary block" v-on:click="$emit('selectCourse', course)">
                  {{ $t('tour_display_detail_label') }}
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <course-modal v-show="modal.show" :closeModal="() => closeModal()">
      <course-detail :createPlan="createPlan" :course="course" @createItem="createItem" :closeModal="() => closeModal()" />
    </course-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CourseModal from "../molecules/CourseModal"
import CourseDetail from '../molecules/CourseDetail'
import Constants from "../../constants"

export default {
  name: 'CourseList',
  components: {
    CourseModal,
    CourseDetail
  },
  props:{
    createPlan: {
      type: Boolean,
      required: false,
      default: true
    },
    areaId: {
      type: String
    },
    areaDetail: {
      type: String
    },
    courseId: {
      type: String
    }
  },
  data () {
    return {
      course: {},
      modal: {
        show: false
      }
    }
  },
  mounted () {
    if (this.courses.length === 0) {
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('courses/fetchAll', this.$route.params.areaId)
        .then(() => {
          this.$store.dispatch('loading/endLoading')
          this.scrollArea()
          if (this.courseId !== null) {
            const course = this.courses.find(c => String(c.id) === this.courseId || c.title === this.courseId)
            if (course !== undefined) {
              this.$emit('selectCourse', course)
            }
          }
        })
    } else {
      this.scrollArea()
    }
  },
  methods: {
    scrollArea () {
      if (this.areaDetail !== null && this.$refs[this.areaDetail] !== undefined) {
        this.$refs[this.areaDetail][0].scrollIntoView({ behavior: 'smooth'})
      }
    },
    showModal (course) {
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('courses/fetchCourseDetail', course.course_id)
        .then(() => {
          this.$store.dispatch('loading/endLoading')
          this.course = this.courseDetail
          this.modal.show = true
        })
    },
    closeModal () {
      this.modal.show = false
    },
    createItem (courseId) {
      // GoogleAnalytics
      this.$gtag.event("コースからプラン作成", {
        course_name: this.course.title
      });
      const areaId = this.$store.getters['user/getAreaId']
      if (areaId == Constants.DEFAULT_AREA_ID){
        this.$router.push({ name: 'newPlan', query: { lang: this.$store.getters['user/getLang'], courseId: courseId } })
      }else{
        this.$router.push({ name: 'newPlan', query: { lang: this.$store.getters['user/getLang'], courseId: courseId}, params:{areaId: areaId } })
      }
    },
    getCourses (area) {
      return this.courses.filter(course => course.area === area)
    }
  },
  computed: {
    ...mapGetters({
      courses: 'courses/getAll',
      courseDetail: 'courses/getCourseDetail'
    }),
    getAreas: function () {
      let areas = []
      for (let i = 0; i < this.courses.length; i++) {
        if (areas.indexOf(this.courses[i].area) === -1) {
          areas.push(this.courses[i].area)
        }
      }
      return areas
    }
  }
}
</script>
